import { useState, useEffect } from "react";
import { API_REGION_VERSION_MAP } from "../utils";
import axios from "axios";

const removeHyphen = (hyphenatedLocale: string) => {
  const region = hyphenatedLocale.split("-")[1].toUpperCase();
  return hyphenatedLocale.split("-")[0] + region;
};

export const useSetMemberInfo = (UID?: string, groupId?: string) => {
  const [loadingMemberInfo, setLoadingMemberInfo] = useState(true);
  const [memberInfoError, setMemberInfoError] = useState(false);
  const [memberInfo, setMemberInfo] = useState([
    {
      memberUid: "",
      role: "",
      status: "",
      groupId: "",
    },
  ]);
  const [memberInfoResp, setMemberInfoResp] = useState();
  const apiVersion =
    API_REGION_VERSION_MAP[removeHyphen(process.env.REACT_APP_LOCALE!)];

  useEffect(() => {
    if (
      UID &&
      groupId &&
      (memberInfo[0].memberUid || memberInfo[0].role || memberInfo[0].status)
    ) {
      const promiseArr = memberInfo.map(async (info) => {
        window.gigya.accounts.getJWT({
          UID,
          callback: (resp) => {
            if (resp["errorCode"] === 0) {
              const headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${resp.id_token}`,
              };
              const apiKey = process.env.REACT_APP_CDC_API_KEY ?? "";
              const SetMemberInfoUrl = `${process.env.REACT_APP_CDC_API_BASEURL}/${process.env.REACT_APP_CDC_API_VERSION}/cdc/groups/setMemberInfo`;
              const SetMemberInfoUrlTW = `${process.env.REACT_APP_CDC_API_BASEURL}/${apiVersion}/cdc/groups/setMemberInfo`;
              axios.post(
                process.env.REACT_APP_LOCALE !== "en-us"
                  ? SetMemberInfoUrlTW
                  : SetMemberInfoUrl,
                {
                  apiKey,
                  groupId: info.groupId,
                  memberUid: info.memberUid,
                  role: info.role,
                  status: info.status,
                },
                { headers },
              );
            }
          },
        });
      });

      Promise.all(promiseArr)
        .then((responseArr) => {
          setMemberInfo([{ memberUid: "", role: "", status: "", groupId: "" }]);
          setLoadingMemberInfo(false);
          setMemberInfoError(false);
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log("Error Data: ", error.response.data);
            console.log("Erorr Status: ", error.response.status);
            console.log("Error Headers: ", error.response.headers);
            setLoadingMemberInfo(true);
            setMemberInfoError(true);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(
              "There was an error with your request: ",
              error.request,
            );
            setLoadingMemberInfo(true);
            setMemberInfoError(true);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error: ", error.message);
            setLoadingMemberInfo(true);
            setMemberInfoError(true);
          }
          console.log("Error config: ", error.config);
          setLoadingMemberInfo(true);
          setMemberInfoError(true);
        });
    }

    return () => {
      setMemberInfo([{ memberUid: "", role: "", status: "", groupId: "" }]);
      setLoadingMemberInfo(true);
      setMemberInfoError(false);
    };
  }, [memberInfo[0].memberUid, memberInfo[0].role, memberInfo[0].status]);

  return {
    memberInfoResp,
    setMemberInfo,
    loadingMemberInfo,
    memberInfoError,
  };
};
